import { defineAsyncComponent } from 'vue';
const ProductoCamaraStandard = defineAsyncComponent(() =>
  import('@/pages/Productos/components/tipo/ProductoCamaraStandard.vue')
);
const ProductoCamara = defineAsyncComponent(() =>
  import('@/pages/Productos/components/tipo/ProductoCamara.vue')
);
const ProductoEquipo = defineAsyncComponent(() =>
  import('@/pages/Productos/components/tipo/ProductoEquipo.vue')
);
const ProductoPanel = defineAsyncComponent(() =>
  import('@/pages/Productos/components/tipo/ProductoPanel.vue')
);
const ProductoPuerta = defineAsyncComponent(() =>
  import('@/pages/Productos/components/tipo/ProductoPuerta.vue')
);
const ProductoAccesorio = defineAsyncComponent(() =>
  import('@/pages/Productos/components/tipo/ProductoAccesorio.vue')
);
const ProductoServicio = defineAsyncComponent(() =>
  import('@/pages/Productos/components/tipo/ProductoServicio.vue')
);
const ProductoPerfil = defineAsyncComponent(() =>
  import('@/pages/Productos/components/tipo/ProductoPerfil.vue')
);
const ProductoChapa = defineAsyncComponent(() =>
  import('@/pages/Productos/components/tipo/ProductoChapa.vue')
);

const componentMapping = {
  WPAN: ProductoPanel,
  WCNE: ProductoCamara,
  WEQU: ProductoEquipo,
  WPUE: ProductoPuerta,
  WACC: ProductoAccesorio,
  WCAM: ProductoCamaraStandard,
  WSER: ProductoServicio,
  WCHA: ProductoChapa,
  WPER: ProductoPerfil,
};

export default componentMapping;
